import Http from '../http'

export default {

  index(filter) {
    // let search = ''
    // const {limit, page, level} = filter
    // search = `_page=${page}&_limit=${limit || 1000}&attributes.level=${level}`

    return Http.get(`/projects`, {params: {...filter}})
  },

  create(project){
    return Http.post(`/projects`, {project: {
      ...project,
    }})
  },

  update(project){
    return Http.put(`/projects/${project.id}`, {
      project: {
        ...project,
      },
    });
  },

  show(id) {
    return Http.get(`/projects/${id}`);
  },

  delete(){
    // return Http.delete(`/action_plans/${id}`)
  }

}
